const getUseSessionStorage = () => {
  const viteFlag = typeof import.meta !== 'undefined' ? import.meta.env?.VITE_USE_SESSION_STORAGE : undefined;
  const reactFlag = typeof process !== 'undefined' ? process.env?.REACT_APP_USE_SESSION_STORAGE : undefined;
  return String(viteFlag || reactFlag || 'false').toLowerCase() === 'true';
};

const getPrimaryStorage = () => {
  if (typeof window === 'undefined') return null;
  return getUseSessionStorage() ? window.sessionStorage : window.localStorage;
};

const getFallbackStorage = () => {
  if (typeof window === 'undefined') return null;
  return getUseSessionStorage() ? window.localStorage : window.sessionStorage;
};

const authStorage = {
  getItem: (key) => {
    const primary = getPrimaryStorage();
    const fallback = getFallbackStorage();
    return primary?.getItem(key) ?? fallback?.getItem(key) ?? null;
  },
  setItem: (key, value) => {
    const primary = getPrimaryStorage();
    if (!primary) return;
    primary.setItem(key, value);
  },
  removeItem: (key) => {
    const primary = getPrimaryStorage();
    const fallback = getFallbackStorage();
    primary?.removeItem(key);
    fallback?.removeItem(key);
  }
};

export default authStorage;
